import { flow } from 'lodash';

import { NAME } from './receipt.constant';

const selectStateKey = (state) => state[NAME];

export const selectState = flow(selectStateKey);
